








































































































































import Vue from 'vue'

export default Vue.extend({
  name: 'DatabasesStatus',
  props: {
    show: {
      type: Boolean,
      default: false
    },
    close: {
      type: Function,
      default: () => {}
    },
    databases: {
      type: Array,
      default: () => [],
      required: true
    }
  }
})
